import { createContext } from 'react';
import { NavContextProps } from './SideNavTypes';

export const NavContext = createContext<NavContextProps>(null);
